import React from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    critical: {
        backgroundColor: 'rgba(229, 57, 53, 0.1)',
        color: theme.palette.error.main,
        fontWeight: 600,
        fontSize: 11
    },
    warning: {
        backgroundColor: 'rgba(255, 152, 0, 0.1)',
        color: theme.palette.warning.main,
        fontWeight: 600,
        fontSize: 11
    },
    ok: {
        backgroundColor: 'rgba(76, 175, 80, 0.1)',
        color: theme.palette.success.main,
        fontWeight: 600,
        fontSize: 11
    }
}));

/**
 * SeverityBadge component for displaying severity levels
 * @param {string} severity - 'critical', 'warning', or 'ok'
 */
const SeverityBadge = ({ severity }) => {
    const classes = useStyles();

    const labels = {
        critical: 'Critical',
        warning: 'Warning',
        ok: 'OK'
    };

    return (
        <Chip
            label={labels[severity] || severity}
            size="small"
            className={classes[severity]}
        />
    );
};

export default SeverityBadge;
